//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import {
	Column,
	Part,
	TitleSection,
	SubtitleSection,
	ParagraphSection,
	Fields,
} from "components/styles";
//#endregion
//#region Components
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import HandleRadio from "components/CustomRadio/CustomRadio";
import OnlyDayFields from "views/components/Duration/OnlyDayFields/OnlyDayFields";
import ManyDaysFields from "views/components/Duration/ManyDaysFields/ManyDaysFields";
//#region Utils
import { ALLOW_DURATION_EVENT_UPDATE } from "config/deploymentMode";
import { eventsSessionStorage } from "services/storage/events";
import { EVENTS_CONSTANTS, EVENT_PERIODS } from "config/constants";
//#endregion

const { EVENT_PERIOD_IDS, EVENT_TYPES } = EVENTS_CONSTANTS;

const Part3 = ({
	form,
	changeField,
	eventTypeId,
	allDays,
	errors,
	eventResumeData,
	changeErrorManyDaysTime,
	isCreate,
	isCulturalOrSport
}) => {
	const { period, hasWaitlist } = form;
	// const [canUpdateEventDuration, setCanUpdateEventDuration] = useState(true);
	const [
		disableControlsForNoLongerDraft,
		setDisableControlsForNoLongerDraft,
	] = useState({
		onlyDay: false,
		manyDays: false,
	});
	const [hasWaitlistLocal, setWaitlist] = useState(hasWaitlist);
	useEffect(() => {
		if (!eventResumeData) return;
		if (ALLOW_DURATION_EVENT_UPDATE) return;
		const isDraft = eventsSessionStorage.isDraftEvent.get();
		setDisableControlsForNoLongerDraft({
			onlyDay:
				!isDraft &&
				eventResumeData.step1.duration.period ===
					EVENT_PERIOD_IDS.MANY_DAYS,
			manyDays: !isDraft && eventResumeData.step1.duration.period,
		});
	}, [eventResumeData]);
	useEffect(() => {
		changeField("hasWaitlist", hasWaitlistLocal, false)
	}, [hasWaitlistLocal])
	//#region Functions
	const changePeriod = value => {
		changeField("period", value, false);
	};
	const toggleHasWaitlist = value => {
		//value = !!form.duration.manyDays.date.waitlist && !isCreate
		setWaitlist(value)
		//changeField("hasWaitlist", value, false);
	};
	const changeDuration = (field, value, errorValue) => {
		changeField(
			"duration",
			{
				...form.duration,
				[field]: value,
			},
			{
				...errors.duration,
				[field]: errorValue,
			}
		);
	};
	const changeDurationOnlyDayFields = (value, errorValue) =>
		changeDuration("onlyDay", value, errorValue);
	const changeDurationManyDaysFields = (value, errorValue) =>
		changeDuration("manyDays", value, errorValue);
	//#endregion	
	return (
		<Part paddingBottom="80px">
			<Fields>
				<Column>
					<Column>
						<TitleSection>Duración</TitleSection>
						{eventTypeId === EVENT_TYPES.WORK_SHOP && (
							<ParagraphSection>
								Selecciona una opción
							</ParagraphSection>
						)}
					</Column>
				</Column>
				{eventTypeId === EVENT_TYPES.WORK_SHOP && (
					<Column>
						<SubtitleSection>Período:</SubtitleSection>
						<HandleRadio
							value={form.period}
							onChange={changePeriod}
							radiosProps={EVENT_PERIODS}
							error={errors.period}
							disabled={
								disableControlsForNoLongerDraft.onlyDay ||
								disableControlsForNoLongerDraft.manyDays
							}
							errorText="Es necesario seleccionar un período"
						/>
					</Column>
				)}
				{!period ? (
					<NotificationNoContent
						title={
							eventTypeId === EVENT_TYPES.WORK_SHOP
								? "Aún no has señalado un período"
								: "Aún no has señalado un tipo de evento"
						}
						description="Selecciona uno para mostrarte las opciones de fechas y horas"
					/>
				) : period === EVENT_PERIOD_IDS.ONLY_DAY ? (
					<OnlyDayFields
						duration={form.duration.onlyDay}
						changeDuration={changeDurationOnlyDayFields}
						errors={errors.duration.onlyDay}
						disableControls={
							disableControlsForNoLongerDraft.onlyDay
						}
					/>
				) : (
					period === EVENT_PERIOD_IDS.MANY_DAYS && (
						<ManyDaysFields
							duration={form.duration.manyDays}
							allDays={allDays}
							changeDuration={changeDurationManyDaysFields}
							errors={errors.duration.manyDays}
							changeErrorManyDaysTime={changeErrorManyDaysTime}
							disableControls={
								disableControlsForNoLongerDraft.manyDays
							}
							isCreate={isCreate}
							toggleHasWaitlist={toggleHasWaitlist}
							hasWaitlist={hasWaitlistLocal}
							isCulturalOrSport={isCulturalOrSport}
						/>
					)
				)}
			</Fields>
		</Part>
	);
};

export default Part3;
